// import

import {styled} from 'goober';
import type {ComponentProps} from 'react';

import type {PostNode} from 'libs/model';
import {Header, Meta, BannerImage} from 'modules/Solo';
import {TypeCapture} from 'modules/Type';

import {MoreLink} from './MoreLink';

// types

type Props = ComponentProps<typeof Article> & {
  post: PostNode;
};

// component

export function Post(props: Props) {
  const {post, ...rest} = props;

  return (
    <Article {...rest} data-test="post">
      <BannerImage node={post} />

      <Header link className="header" node={post} />
      <Meta className="meta" node={post} />

      <TypeCapture className="body" html={post.clip} />
      <MoreLink href={post.meta.link}>Read more</MoreLink>
    </Article>
  );
}

// styles

const Article = styled('article')`
  .header {
    margin-top: 0.5rem;
  }

  .body {
    margin: 1rem 0;
  }

  @media (max-width: 35.99875em) {
    .header h1 {
      font-size: 2.5rem;
      line-height: 2.75rem;
    }
  }

  @media (max-width: 26.99875em) {
    .header h1 {
      font-size: 2rem;
      line-height: 2.25rem;
    }
  }
`;
